import parse, { Element } from 'html-react-parser'
import React from 'react'

import { CustomizableComponent } from '@contracts/components/customizableComponent'

import * as styles from './Wysiwyg.module.scss'

interface Props extends CustomizableComponent {
	data: string
	isPageContent?: boolean
	headingIds?: boolean
}

const Wysiwyg: React.FunctionComponent<Props> = React.forwardRef((props, ref: React.ForwardedRef<HTMLDivElement>) => {
	const contentStyles = [styles.wysiwyg]

	if (props.className) {
		contentStyles.push(props.className)
	}

	if (props.isPageContent) {
		contentStyles.push(styles.pageContent)
	}

	const slugify = (text: string) => {
		return (
			'toc-' +
			text
				.toLowerCase()
				.replace(/[^\w\s-]/g, '')
				.replace(/\s+/g, '-')
		)
	}

	const replaceContent = (html: string) => {
		return parse(html, {
			replace(domNode, index) {
				if (domNode instanceof Element && domNode.attribs) {
					if (domNode.type === 'tag' && (domNode.name === 'h2' || domNode.name === 'h3')) {
						let headingContent = null
						if (domNode.children.length) {
							domNode.children.forEach((childEl) => {
								if (childEl.type === 'text') {
									headingContent = childEl.data
								}

								if (childEl.type === 'tag') {
									// @ts-ignore
									headingContent = childEl.children[0].data
								}
							})
						}

						if (headingContent !== null) {
							domNode.attribs.id = slugify(headingContent)
						}
					}
				}
			},
		})
	}

	if (props.headingIds) {
		return (
			<div className={contentStyles.join(' ')} ref={ref}>
				{replaceContent(props.data)}
			</div>
		)
	}

	return <div className={contentStyles.join(' ')} dangerouslySetInnerHTML={{ __html: props.data }} ref={ref}></div>
})

export default Wysiwyg
